import { render, staticRenderFns } from "./radio-quarternary.vue?vue&type=template&id=204bfb94&scoped=true&"
import script from "./radio-quarternary.vue?vue&type=script&lang=js&"
export * from "./radio-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204bfb94",
  null
  
)

export default component.exports